import { render, staticRenderFns } from "./ChoppingTasks.vue?vue&type=template&id=da12052e&scoped=true&"
import script from "./ChoppingTasks.vue?vue&type=script&lang=js&"
export * from "./ChoppingTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da12052e",
  null
  
)

export default component.exports